// License Links filter registry. Drives the Links tab on the license
// detail page.

import type { FilterRegistry } from './types';

const LICENSE_LINKS_LIST_KEYS: ReadonlyArray<string> = [
	'license-links-embedded',
];

export const licenseLinksFilters: FilterRegistry = {
	linkSide: {
		type: 'multi-select',
		label: 'Side',
		placeholder: 'Select side...',
		colorScheme: 'blue',
		searchable: false,
		loadOnFocus: false,
		displayFields: {
			id: 'id' as keyof unknown,
			primary: 'label' as keyof unknown,
		},
		options: [
			{ id: 'individual', label: 'Individual' },
			{ id: 'facility', label: 'Facility' },
		],
		queryParamName: 'linkSide',
		multiple: true,
		valueExtractor: { property: 'id' },
		queryMapping: {
			objectTable: 'lm_individual_facility_links',
			fieldName: 'counterparty_side',
			joinType: 'custom',
		},
		format: 'array',
		listKeys: [...LICENSE_LINKS_LIST_KEYS],
	},

	linkRole: {
		type: 'multi-select',
		label: 'Role',
		placeholder: 'Select role...',
		colorScheme: 'purple',
		searchable: false,
		loadOnFocus: false,
		displayFields: {
			id: 'id' as keyof unknown,
			primary: 'label' as keyof unknown,
		},
		// Static set covers the roles seeded by the matchmaker; long-tail
		// custom roles still match via string equality.
		options: [
			{ id: 'pharmacist_in_charge', label: 'Pharmacist in Charge' },
			{ id: 'staff_pharmacist', label: 'Staff Pharmacist' },
			{ id: 'pharmacy_technician', label: 'Pharmacy Technician' },
			{ id: 'owner', label: 'Owner' },
			{ id: 'manager', label: 'Manager' },
			{ id: 'other', label: 'Other' },
		],
		queryParamName: 'linkRole',
		multiple: true,
		valueExtractor: { property: 'id' },
		queryMapping: {
			objectTable: 'lm_individual_facility_links',
			fieldName: 'role',
			joinType: 'custom',
		},
		format: 'array',
		listKeys: [...LICENSE_LINKS_LIST_KEYS],
	},

	linkSource: {
		type: 'multi-select',
		label: 'Source',
		placeholder: 'Select source...',
		colorScheme: 'green',
		searchable: false,
		loadOnFocus: false,
		displayFields: {
			id: 'id' as keyof unknown,
			primary: 'label' as keyof unknown,
		},
		options: [
			{ id: 'state_board', label: 'State Board' },
			{ id: 'cross_reference', label: 'Cross Reference' },
			{ id: 'tenant_confirmed', label: 'Tenant Confirmed' },
			{ id: 'manual', label: 'Manual' },
		],
		queryParamName: 'linkSource',
		multiple: true,
		valueExtractor: { property: 'id' },
		queryMapping: {
			objectTable: 'lm_individual_facility_links',
			fieldName: 'link_source',
			joinType: 'custom',
		},
		format: 'array',
		listKeys: [...LICENSE_LINKS_LIST_KEYS],
	},

	linkStatus: {
		type: 'multi-select',
		label: 'Counterparty Status',
		placeholder: 'Select status...',
		colorScheme: 'orange',
		searchable: false,
		loadOnFocus: false,
		displayFields: {
			id: 'id' as keyof unknown,
			primary: 'label' as keyof unknown,
		},
		// Matches lm_registry / lm_source_state_board raw status. Free-text
		// values exist beyond this list — those still flow through as the
		// values the user picks; the option set is just convenience.
		options: [
			{ id: 'Active', label: 'Active' },
			{ id: 'Expired', label: 'Expired' },
			{ id: 'Pending', label: 'Pending' },
			{ id: 'Revoked', label: 'Revoked' },
			{ id: 'Suspended', label: 'Suspended' },
			{ id: 'Cancelled', label: 'Cancelled' },
		],
		queryParamName: 'linkStatus',
		multiple: true,
		valueExtractor: { property: 'id' },
		queryMapping: {
			objectTable: 'lm_individual_facility_links',
			fieldName: 'counterparty_status',
			joinType: 'custom',
		},
		format: 'array',
		listKeys: [...LICENSE_LINKS_LIST_KEYS],
	},
};
